<style></style>
<template>
  <div class="autographList-box">
    <p class="title">短信配置&nbsp;&nbsp;<strong>[ 签名 ]</strong></p>
    <tips></tips>
    <div class="mb20 order-search-wrap">
      <span class="ml20">签名名称：</span>
      <el-input v-model.trim="signName" class="mr20" style="width:200px;" @keyup.enter.native="getAutographList()" prefix-icon="el-icon-search" placeholder="输入签名名称" clearable></el-input>
      <span>审核状态：</span>
      <el-select v-model="isAuditing" @change="getAutographList()">
        <el-option label="全部" :value="-1"></el-option>
        <el-option label="有效" :value="0"></el-option>
        <el-option label="待审核" :value="1"></el-option>
        <el-option label="拒绝" :value="2"></el-option>
      </el-select>
      <el-button type="primary" class="ml20" @click="getAutographList()" >查询</el-button>
      <span class="addBtn">
        <el-button type="primary" style="padding:8px 12px" @click="creatAutograph">
          <i class="el-icon-circle-plus"></i>&nbsp;创建签名
        </el-button>
      </span>
    </div>
    <div class="table-wrapper1">
      <el-table :data="autographData" border  v-loading = "loading" highlight-current-row ref="table" :max-height="tableHeight">
        <el-table-column label="签名"  prop="signName" width = '120px'></el-table-column>
        <el-table-column label="审核资料" width="80">

          <template slot-scope="scope">
            <el-popover
              placement="right"
              title=""
              trigger="click">
              <img :src="scope.row.signPicUrl" width="530" height="730" />
              <img slot="reference" :src="scope.row.signPicUrl" :alt="scope.row.signPicUrl" style="max-height: 30px;max-width: 30px">
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="申请原因" prop="signReason" show-overflow-tooltip></el-table-column>
        <!--<el-table-column label="用户名称" prop="userName"></el-table-column>-->
        <el-table-column label="是否对下级公用" width="120">
          <template slot-scope="scope">
            <span style="color: #67c23a" v-if="scope.row.isPublic">是</span>
            <span style="color: gray"  v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="80">
          <template slot-scope="scope">
            <span style="color: #67c23a" v-if="scope.row.isAuditing == 0">通过</span>
            <span style="color: orange" v-else-if="scope.row.isAuditing == 1">审核中</span>
            <span style="color: red"  v-else>拒绝</span>
          </template>
        </el-table-column>
        <el-table-column label="是否为自身签名" width="120">
          <template slot-scope="scope">
              <span style="color: #67c23a" v-if="scope.row.self">是</span>
              <span style="color: gray"  v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="失败原因" prop="reason" show-overflow-tooltip></el-table-column>
         <el-table-column label="创建时间" prop="createtimeStr"></el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <span class="text-blue pointer" @click="revise(scope.row)" v-if="scope.row.isAuditing !=0 && scope.row.self">修改 |</span>
            <span class="text-red pointer" @click="deleteRow(scope.row)" v-if="scope.row.self"> 删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="txt-r mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
    <creat v-if="show" @closeComponent='close' :data='reviseData'></creat>
  </div>
</template>
<script>
import tips from '../../components/message/tips'
import creat from '../../components/message/creatAutograph'
import api from '../../server/api.js'
export default {
  name: "autographList",
  data(){
    return{
      tableHeight: 100,
      loading:false,
      signName:"",
      isAuditing: -1,
      pageSize: 10,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      autographData: [],
      show: false,
      reviseData: null,
    };
  },
  created(){
    this.getAutographList();
  },
  methods: {
    getAutographList(){//获取签名列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        "signName": this.signName,
        // "mouldSign": 
        // "mouldName": 
        "isAuditing": this.isAuditing==-1 ? null : this.isAuditing
      }
      this.loading =true;
      api.autographList({data:data}).then(res => {
        this.loading =false;
        if(res.status == 'success'){
          this.tableHeight =
            window.innerHeight - this.$refs.table.$el.offsetTop - 100;
          this.autographData = res.data.resultList;
          this.total = res.data.count;
        }
      })
    },
    creatAutograph(){//创建签名
    this.reviseData = null;
      this.show = true;
    },
    revise(row){//修改签名
      this.reviseData = row;
      this.show = true;
    },
    close(){//关闭创建
      this.show = false;
      this.getAutographList();
    },
    deleteRow(row,index){//删除签名
      this.$confirm('此操作将永久删除该签名, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arr = [];
        arr[0] = row.signSign;
        api.delAutograph({data:{"signSignList": arr}}).then(res =>{
          if(res.status == 'success'){
            this.$message.success(res.msg);
            this.autographData.splice(index,1)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getAutographList();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getAutographList();
    },
  },
  components: {
    tips,creat,
  }
}
</script>
  




// WEBPACK FOOTER //
// src/view/message/autographList.vue